import { createAsyncThunk } from '@reduxjs/toolkit';
import { getHsaContributionNotForwardedStatuses } from 'shared/api/contributionStatusesApi';

export let fetchHsaContributionsNotForwarded = createAsyncThunk(
  'actionItems/fetchContributionsNotForwarded',
  (companyId: number) => {
    return getHsaContributionNotForwardedStatuses(companyId);
  },
);
